import React from "react";
import { CASE_TYPES } from "./data/constants";

export default function CaseTypeSelector({ caseType, onChange }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mb-6">
      {CASE_TYPES.map((c) => {
        const Icon = c.icon;
        const active = caseType === c.id;
        return (
          <button
            key={c.id}
            onClick={() => onChange(c.id)}
            className={`flex flex-col items-center justify-center gap-2 rounded-xl px-3 py-4 text-xs transition-all text-neutral-200
              ${active ? "bg-primary " : "bg-neutral-800"}
              `}
          >
            <Icon size={18} />
            <span className="text-center leading-4">{c.label}</span>
          </button>
        );
      })}
    </div>
  );
}
